import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(landing-page)/_components/dynamic-cta-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(landing-page)/_components/sections/newsletter-cta-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/fancy/video-player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/magicui/avatar-circles.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/magicui/blur-fade.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/magicui/shine-border.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTriggerWithIcons","AccordionContent"] */ "/vercel/path0/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.0-canary.47_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_l5xoos4fzweak7kjzpeukgm37e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.0-canary.47_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_l5xoos4fzweak7kjzpeukgm37e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.0-canary.47_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_l5xoos4fzweak7kjzpeukgm37e/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.0-canary.47_@babel+core@7.24.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler_l5xoos4fzweak7kjzpeukgm37e/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
